import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_Resource } from '../../../../../_entity.js';
import './Renderer_ResourceHeader.scss';
export class Renderer_ResourceHeader extends ComponentSync {
    __onResourcesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.resource?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ resource: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.resource?._id)
            state.resource = ModuleFE_Resource.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'resource-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'resource-header__title', children: this.state.resource?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const resource = this.state.resource;
        if (!resource?.type)
            return;
        return _jsx("span", { className: 'resource-header__sub-title', children: resource.type });
    };
}
//# sourceMappingURL=Renderer_ResourceHeader.js.map